import { ActivityRepositoryInterface } from "@/data/persistences/repositories/contracts/ActivityRepositoryInterface";
import ApiService from "../../services/ApiService";
import { ActivityMapper } from "@/data/persistences/mappers/ActivityMapper";
import { ActivityEndpoint } from "../../endpoints/horde/ActivityEndpoint";
import { SendActivityApiRequest } from "@/data/payload/api/ActivityApiRequest";

export class ActivityApiRepository implements ActivityRepositoryInterface {
  private service: ApiService;
  private mapper: ActivityMapper;
  private endpoint: ActivityEndpoint;

  constructor(
    service: ApiService,
    mapper: ActivityMapper,
    endpoint: ActivityEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoint = endpoint;
  }

  async sendActivity(payload: SendActivityApiRequest): Promise<boolean> {
    const activityHeader = payload.activityHeader;

    await this.service.invoke(
      "POST",
      this.endpoint.activity(),
      undefined,
      payload,
      new Map([["X-Activity", activityHeader]])
    );

    return true;
  }
}
